<template>
  <!-- ── 鏈 / 錢包選單 ── -->
  <div :class="isPC ? 'colu colu-6 flex-colu' : 'colu colu-12'">
    <label class="colu-12 for-label">
      <template v-if="isCrypto">
        {{ $t('Bao.withdrawal_target') }}
      </template>
      <template v-else>
        {{ isPC ? $t('Bao.withdrawal_wallet') : $t('Bao.withdrawal_source') }}
      </template>
    </label>

    <div :class="isPC ? 'withdraw-right-wrap' : 'custom-select-wrap'">
      <div v-if="isCrypto" class="lang-select" data-id="withdraw-right-custom">
        <!-- 觸發按鈕 -->
        <button
          :id="isPC ? 'withdraw-right-btn' : undefined"
          :class="isPC ? 'btn-select' : 'cs-btn'"
          @click.prevent="isOpenChain = !isOpenChain"
        >
          <span :class="isPC ? 'wr-text' : ''">
            {{ selectedChain ? selectedChain.chain : '' }}
          </span>
        </button>

        <!-- 下拉選單 -->
        <div v-if="isPC" class="b" :class="{ active: isOpenChain }">
          <ul id="withdraw-right-list" class="wr-list">
            <li
              v-for="(chainObj, index) in chainList"
              :key="index"
              @click="onSelectChain(chainObj)"
            >
              {{ chainObj.chain }}
            </li>
          </ul>
        </div>

        <!-- Mobile 用 ul.cs-list -->
        <ul v-else class="cs-list" :class="{ active: isOpenChain }">
          <li
            v-for="(chainObj, index) in chainList"
            :key="index"
            @click="onSelectChain(chainObj)"
          >
            {{ chainObj.chain }}
          </li>
        </ul>
      </div>
      <input
        v-else
        id="withdraw-right-static"
        class="for-input inpType"
        type="text"
        :value="$t('Bao.main_wallet')"
        readonly
      >
    </div>
  </div>
</template>

<script>
import { detectMob } from '@/utils/tool'

export default {
  name: 'WalletSelector',
  props: {
    /** 是否為加密幣模式 */
    isCrypto: {
      type: Boolean,
      default: false
    },
    selectedChain: {
      type: Object,
      default: null
    },
    chainList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      isOpenChain: false
    }
  },
  computed: {
    isPC() {
      return !detectMob()
    }
  },
  methods: {
    onSelectChain(chainObj) {
      this.isOpenChain = false
      this.$emit('select-chain', chainObj)
    }
  }
}
</script>
